module.exports = __webpack_public_path__ + "static/handyman-69cf14d9126f93bcc3b5de657a2b7f59.png";